<template>
  <div class="d-flex flex-column align-items-center">
    <div class="app-container col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3">
      <div class="content-container">
        <LoadingOverlay v-if="isLoading"/>
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component"/>
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {mapState} from "vuex";
import {setBrandConfig} from "@/functions/setBrandConfig";

export default {
  components: {LoadingOverlay},
  computed: {
    ...mapState(['isLoading', 'brandConfig']),
  },
  beforeMount() {
    setBrandConfig();
    this.setTabName();
    this.injectTealium();
  },
  methods: {
    setTabName() {
      document.title = this.brandConfig?.productTitle;
    },
    injectTealium() {
      (function (a, b, c, d) {
        a = 'https://tags.tiqcdn.com/utag/vodafone/za-quizinc-main/prod/utag.js';
        b = document;
        c = 'script';
        d = b.createElement(c);
        d.src = a;
        d.type = 'text/java' + c;
        d.async = true;
        a = b.getElementsByTagName(c)[0];
        a.parentNode.insertBefore(d, a);
      })();
    }
  }
};
</script>

<style>
html, body {
  overflow-x: hidden;
  max-width: 100%;
}

img {
  max-width: 100%;
  height: auto;
}

.app-container {
  height: 100vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  display: none;
}

.content-container {
  z-index: 1;
  background: #ffffff;
  min-height: 100vh;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@keyframes grFadeInUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes grPopIn {
  0% { opacity: 0; transform: scale(0.85); }
  60% { opacity: 1; transform: scale(1.03); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes grFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes grShimmer {
  0% { background-position: -150% 0; }
  100% { background-position: 250% 0; }
}

@keyframes grShake {
  10%, 90% { transform: translateX(-2px); }
  20%, 80% { transform: translateX(4px); }
  30%, 50%, 70% { transform: translateX(-7px); }
  40%, 60% { transform: translateX(7px); }
}

@keyframes grPulseGlow {
  0%, 100% { filter: drop-shadow(0 0 0 rgba(65, 105, 225, 0)); }
  50% { filter: drop-shadow(0 0 10px rgba(65, 105, 225, 0.65)); }
}

.gr-in { animation: grFadeInUp 0.5s ease both; }
.gr-pop { animation: grPopIn 0.5s cubic-bezier(0.2, 0.8, 0.3, 1.2) both; }
.gr-float { animation: grFloat 3.6s ease-in-out infinite; }

.gr-stagger > * { animation: grFadeInUp 0.5s ease both; }
.gr-stagger > *:nth-child(1) { animation-delay: 0.04s; }
.gr-stagger > *:nth-child(2) { animation-delay: 0.10s; }
.gr-stagger > *:nth-child(3) { animation-delay: 0.16s; }
.gr-stagger > *:nth-child(4) { animation-delay: 0.22s; }
.gr-stagger > *:nth-child(5) { animation-delay: 0.28s; }
.gr-stagger > *:nth-child(6) { animation-delay: 0.34s; }
.gr-stagger > *:nth-child(7) { animation-delay: 0.40s; }
.gr-stagger > *:nth-child(8) { animation-delay: 0.46s; }
.gr-stagger > *:nth-child(9) { animation-delay: 0.52s; }
.gr-stagger > *:nth-child(10) { animation-delay: 0.58s; }

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}
</style>
